import { createAsyncAction } from 'typesafe-actions';
var actions = {
    fetch: createAsyncAction('fetch/request', 'fetch/success', 'fetch/failure')(),
    save: createAsyncAction('save/request', 'save/success', 'save/failure')()
};
export default actions;
//# sourceMappingURL=actions.js.map